import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FormGroup, Input, Col, Row, Container, Table } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import utils from '../../resources/utils';
import DataObject from '../../components/DataObject';
import DataRow from '../../components/DataRow';
import './index.css';

// The Roster component matches one of two different routes
// depending on the full pathname
export default class DashboardsScreen extends React.Component {
    constructor(props) {
        super(props);
        const queries = utils.parseQueryParams(this.props);
        this.state = {
            selectedDatabaseId: this.props.match.params.database_id || null,
            dashboards: [],
            isGrantingPermission: queries.is_granting_permission || false,
            userId: queries.user_id || 0,
            isAddNew: false,
            createNewDatasourceType: '',
        }
    }
    componentWillMount() {
        this.getDashboards();
    }
    componentDidMount = () => {
    }
    getDashboards() {
        const {  isGrantingPermission, userId } = this.state;
        let uri = `dashboards`;

        if (userId && isGrantingPermission) {
            uri = `${uri}?permission_user_id=${userId}`;
        }
        api.fetchAPI({
            method: 'get',
            uri,
            success: (response) => {
                this.setState({ dashboards: response.dashboards });
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    render() {
        const { dashboards, isGrantingPermission, userId } = this.state;
        return (
            <div style={{ marginTop: 12 }}>
                <Row>
                    <Col xs={12}>
                        <Button
                            tag={Link}
                            color="primary"
                            to={'/create-dashboard'}
                        >
                            Add new dashboard
                        </Button>
                    </Col>
                </Row>
                <br />
                <br />
                {dashboards && dashboards.length > 0 &&
                    <Row>
                        <Col xs={12}>
                            <Table striped hover responsive>
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Description</th>
                                        <th>Tag</th>
                                        {isGrantingPermission &&
                                            <th>Allow</th>
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {dashboards.map(dashboard =>
                                        <DataRow
                                            isGrantingPermission={isGrantingPermission}
                                            userId={userId}
                                            dataObject={dashboard}
                                        />
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Dashboards/index.js